export default __webpack_public_path__ + "static/media/bt-fb.c0a1506e.png";